<template>
  <div class="detail-container">
    <van-nav-bar
      :border="false"
      :title="detailData.name"
      left-arrow
      @click-left="$router.back()"
    />
    <van-skeleton :loading="loading" title :row="20" style="background: #fff;">
      <div class="content-box">
        <van-swipe class="my-swipe" :autoplay="5000" height="150" indicator-color="white">
          <van-swipe-item v-for="(i,index) in detailData.pic" :key="index">
            <van-image :src="i" width="100%" height="100%" fit="contain" @click="showPreview(detailData.pic, index)" />
          </van-swipe-item>
        </van-swipe>
        <div v-for="i in detailData.renderInfo" :key="i.label" class="info-item">
          <div class="title">
            {{ i.label }}
          </div>
          <div class="text">
            {{ i.text }}
          </div>
        </div>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
import api from '@/api'
import { ImagePreview } from 'vant'
export default {
  name: 'DiseasePestDetail',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      detailData: {}
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      api.controlAgriDiseasesFindDetail({
        disease_id: this.id
      }).then(({ data }) => {
        let dict = {
          symptom: '特征', // 形态特征(杂草)/为害症状(病/虫)
          etiology: '特点', // 发生特点(杂草)/病原物(病)
          infection_cycle: '分布', // 地理分布(杂草)/侵染循环(病)
          factor: '危害情况/发生因素', // 危害情况(杂草)/发生因素(病/虫)
          prevent: '防治', // 防治方法(虫)/防治方法(病)
          morphology: '形态特征', // 形态特征(虫)
          habits: '生活习性' // 生活习性(虫)
        }
        if (data.type === 'weed') {
          dict = {
            symptom: '形态特征',
            etiology: '发生特点',
            infection_cycle: '地理分布',
            factor: '危害情况',
            prevent: '防治方法'
          }
        } else if (data.type === 'sick') {
          dict = {
            symptom: '为害症状', // 形态特征(杂草)/为害症状(病/虫)
            etiology: '病原物', // 发生特点(杂草)/病原物(病)
            infection_cycle: '侵染循环', // 地理分布(杂草)/侵染循环(病)
            factor: '发生规律', // 危害情况(杂草)/发生规律(病/虫)
            prevent: '防治方法' // 防治方法(虫)/防治方法(病)
          }
        } else if (data.type === 'pest') {
          dict = {
            symptom: '为害症状', // 形态特征(杂草)/为害症状(病/虫)
            factor: '发生规律', // 危害情况(杂草)/发生规律(病/虫)
            prevent: '防治方法', // 防治方法(虫)/防治方法(病)
            morphology: '形态特征', // 形态特征(虫)
            habits: '生活习性' // 生活习性(虫)
          }
        }
        const renderInfo = []
        Object.keys(dict).forEach(key => {
          if (data[key]) {
            renderInfo.push({ label: dict[key], text: data[key] })
          }
        })
        this.detailData = Object.assign(data, { renderInfo })
        this.loading = false
      })
    },
    showPreview(list, index = 0) {
      ImagePreview({
        images: list,
        startPosition: index
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-container {
  position: relative;
  .van-nav-bar {
    position: sticky;
    top: 0;
  }
}
.content-box {
  padding: 10px;
  .title {
    padding: 20px;
    font-size: 24px;
    color: #668398;
    font-weight: 700;
    text-align: center;
  }
  .text {
    color: #2e333b;
    line-height: 2;
  }
}
</style>
